import ProfilePage from "../components/profile";

export default ProfilePage; 